import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter, useLocation, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";
import { GlobalStyle } from "./GlobalStyles";
import ErrorBoundary from "./components/ErrorBoundary";

// Auth
import ActiveAccount from "./pages/auth/active-account";
import ChangePassword from "./pages/auth/change-password";
import Login from "./pages/auth/login";
import PasswordRecovery from "./pages/auth/password-recovery";
import Register from "./pages/auth/register";

// Core pages
import Home from "./pages/home";
import Profile from "./pages/profile";
import Subscription from "./pages/profile/subscriptions";
import Athletes from "./pages/profile/athletes";
import NewAthletes from "./pages/profile/newAthletes";
import SubscriptionAdm from "./pages/profile/subscriptionsAdm";
import SubscriptionEvent from "./pages/profile/subscriptionsEvent";
import Enrollment from "./pages/enrollment";
import EnrollmentUpdate from "./pages/enrollment-update";
import PaymentEnrollment from "./pages/payment-enrollment";
import Check from "./pages/check";
import AllCheck from "./pages/check/allCheck";
import AllCheckCategories from "./pages/check/allCheckAllCategory";
import DividaJander from "./pages/dividaJander/index";
import FinancialDashboard from "./pages/admin/financial-dashboard";

import XiCopaLondrinaDeJiuJitsu2025 from "./pages/tournament/xi-copa-londrina-de-jiu-jitsu-2025";
import EstadualGfTeamAmazonasDeJiuJitsu2025EtapaCareiro from "./pages/tournament/estadual-gfteam-amazonas-de-jiu-jitsu-2025-etapa-careiro";
import CopaArapongasDeJiuJitsu2025 from "./pages/tournament/copa-arapongas-de-jiu-jitsu-2026";

// Tournament main and variants
import Tournament from "./pages/tournament";
import Tournament2 from "./pages/tournament/index2";
import Tournament3 from "./pages/tournament/index3";
import ViiReiDaPraiaBeachWrestiling from "./pages/tournament/vii-rei-da-praia-beach-wrestiling";
import TournamentInternationalCircuit from "./pages/tournament/international-circuit";
import GfTeamAmazonas from "./pages/tournament/gfteam-amazonas";
import ToledoInternationalOpenBrazilianJiuJitsu from "./pages/tournament/toledo-international-open-brazilian-jiu-jitsu-gi-2023";
import _1CopaArenaParintins from "./pages/tournament/1-copa-arena-parintins";
import IReiERainhaDaPraiaBeachBoxingManausAmazonas2023ManausAmazonas from "./pages/tournament/i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023";
import OpenGuaraniacuJiuJitsu2024 from "./pages/tournament/open-guaraniacu-jiu-jitsu-2024";
import CopaAmizadeDeJiuJitsu2024 from "./pages/tournament/copa-amizade-de-jiu-jitsu-2024";
import ViiiReiERainhaDaPraiaBeachWrestling2024 from "./pages/tournament/ix-rei-e-rainha-da-praia-beach-wrestiling-2025";
import SeletivaManausOlimpica2024 from "./pages/tournament/seletiva-manaus-olimpica-2024";
import CopaMestreAcaiDeJiuJitsu2024 from "./pages/tournament/copa-mestre-acai-de-jiu-jitsu-2024";
import XxxiiCopaOrleyLobatoDeJiuJitsu from "./pages/tournament/xxxii-copa-orley-lobato-de-jiu-jitsu";
import IvOpenTerrSantaDeJiuJitsu from "./pages/tournament/iv-open-terra-santa-de-jiu-jitsu";
import XviiCopaParanaDeJiuJitsu from "./pages/tournament/xvii-copa-parana-de-jiu-jitsu";
import IOrixicombatOpenJiuJitsu from "./pages/tournament/i-orixicombat-open-jiu-jitsu";
import IiCopaArenaParintinsDeJiuJitsu from "./pages/tournament/ii-copa-arena-parintins-de-jiu-jitsu";
import ICopaThomasiDeJiuJitsu from "./pages/tournament/i-copa-thomasi-de-jiu-jitsu";
import CopaLoboBravoCresolDeJiuJitsu from "./pages/tournament/copa-lobo-bravo-cressol-de-jiu-jitsu";
import CopaFronteiraDeJiuJitsu from "./pages/tournament/copa-fronteira-de-jiu-jitsu";
import ViiOpenAmazonasTopTeamDeJiuJitsu from "./pages/tournament/vii-open-amazonas-top-team-de-jiu-jitsu";
import ICopaBlackBeltDeJiuJitsu from "./pages/tournament/i-copa-black-belt-de-jiu-jitsu";
import ViReiDaPraiaDeJiuJitsuNoGi from "./pages/tournament/vi-rei-da-praia-de-jiu-jitsu-no-gi";
import IiCopaChampionsKidsDeJiuJitsu from "./pages/tournament/ii-copa-champions-kids-de-jiu-jitsu";
import IiiOpenRochaEMoraesDeJiuJitsu from "./pages/tournament/iii-open-rocha-e-moraes-de-jiu-jitsu";
import IOpenLaranjeirasDoSulDeJiuJitsu from "./pages/tournament/i-open-laranjeiras-do-sul-de-jiu-jitsu";
import EstadualGfTeamAmazonasDeJiuJitsu from "./pages/tournament/estadual-gf-team-amazonas-jiu-jitsu";
import XxixCopaLuisNetoDeJiuJitsu from "./pages/tournament/xxix-copa-luis-neto-jiu-jitsu";
import CopaManacapuruDeJiuJitsu from "./pages/tournament/copa-manacapuru-de-jiu-jitsu";
import EtapaOriximinaXxxiiCopaOrleyDeJiuJitsu from "./pages/tournament/etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu";
import XviiiCopaParanaDeJiuJitsu from "./pages/tournament/xviii-copa-parana-de-jiu-jitsu";
import CopaInTheGuardDeJiuJitsu from "./pages/tournament/copa-in-the-guard-de-jiu-jitsu";
import CopaAmizadeDeJiuJitsu2025 from "./pages/tournament/copa-amizade-de-jiu-jitsu-2025";
import CopaCianorteDeJiuJitsu from "./pages/tournament/copa-cianorte-de-jiu-jitsu";
import ViiCopaCampeoesDeJiuJitsu from "./pages/tournament/vii-copa-campeoes-de-jiu-jitsu-2025";
import CopaTorneioFacilDeJiuJitsu from "./pages/tournament/copa-torneio-facil-de-jiu-jitsu";
import CopaMercosulDeJiuJitsu from "./pages/tournament/copa-mercosul-de-jiu-jitsu-2025";
import Copacondominiomoradaslondrinadejiujitsu from "./pages/tournament/copa-condominio-moradas-londrina-de-jiu-jitsu";
import CopaSantaTerezaDoOesteDeJiuJitsu from "./pages/tournament/copa-santa-tereza-do-oeste-de-jiu-jitsu-2025";
import VOpenTerraSantaDeJiuJitsu2025 from "./pages/tournament/v-open-terra-santa-de-jiu-jitsu-2025";
import IiOpenNhamundaDeJiuJitsu from "./pages/tournament/ii-open-nhamunda-de-jiu-jitsu-2025";
import IiiCopaBjjCascavelDeJiuJitsu2025 from "./pages/tournament/iii-copa-bjj-cascavel-de-jiu-jitsu-2025";
import IiCopaThomasiDeJiuJitsu2025 from "./pages/tournament/ii-copa-thomasi-de-jiu-jitsu-2025";
import OpenCandoiDeJiuJitsu from "./pages/tournament/open-candoi-de-jiu-jitsu-2025";
import CopaMestreDoAcaiDeJiuJitsu2025 from "./pages/tournament/copa-mestre-do-acai-de-jiu-jitsu-2025";
import TournamentBracketsPage from "./components/organisms/tournamentBracket/bracket-screen/index";
import CopaFronteiraDeJiuJitsu2025 from "./pages/tournament/copa-fronteira-de-jiu-jitsu-2025";
import OpenCascavelInternationalDeJiuJitsu2025 from "./pages/tournament/open-cascavel-international-de-jiu-jitsu-2025";
import IiCopaAquilesDeJiuJitsu2025 from "./pages/tournament/ii-copa-aquiles-de-jiu-jitsu-2025";
import CopaLoboBravoCresolDeJiuJitsu2025 from "./pages/tournament/copa-lobo-bravo-cresol-de-jiu-jitsu-2025";
import IValenteKidsDeJiuJitsu2025 from "./pages/tournament/i-valente-kids-de-jiu-jitsu-2025";
import ICopaLeaoDeJudaDeJiuJitsu2025 from "./pages/tournament/i-copa-leao-de-juda-de-jiu-jitsu-2025";
import InvalidateUnpayedCheckoutsPage from "./pages/invalidate-unpayed-checkouts";
import XxxiiiOrleyLobatoDeJiuJitsu2025 from "./pages/tournament/xxxiii-copa-orley-lobato-de-jiu-jitsu-2025";
import OpenFiveDeJiuJitsu2025 from "./pages/tournament/open-five-de-jiu-jitsu-2025";
import ViiiOpenAmazonasTopTeamDeJiuJitsu2025 from "./pages/tournament/viii-open-amazonas-top-team-de-jiu-jitsu-2025";
import IxReiERainhaDaPraiaBeachWrestling2025 from "./pages/tournament/ix-rei-e-rainha-da-praia-beach-wrestiling-2025";
import CopaCianorteDeJiuJitsu2025 from "./pages/tournament/copa-cianorte-de-jiu-jitsu-2025";
import ViiiLijjamCombatDeJiuJitsu2025 from "./pages/tournament/viii-lijjam-combat-de-jiu-jitsu-2025";
import LijjamCombatIxDeJiuJitsu2026 from "./pages/tournament/lijjam-combat-ix-de-jiu-jitsu-2026";
import EstadualGfTeamAmazonasDeJiuJitsu2025 from "./pages/tournament/estadual-gfteam-amazonas-de-jiu-jitsu-2025";
import ICopaEuAmoParintisDeJiuJitsu2025 from "./pages/tournament/i-copa-eu-amo-parintins-de-jiu-jitsu-2025";
import FozOpenConfrontoInternacionalDeJiuJitsu2025 from "./pages/tournament/foz-open-confronto-internacional-de-jiu-jitsu-2025";
import InstrucaoTesteConnectPagbank from "./pages/tournament/instrucao-teste-homologação-pagbank/instrucao-teste-pagbank-connect";
import OpenChallengerDeJiuJitsu2025 from "./pages/tournament/open-challenger-de-jiu-jitsu-2025";
import ViiReiDaPraiaDeJiuJitsuNoGi2025 from "./pages/tournament/vii-rei-da-praia-de-jiu-jitsu-no-gi-2025";
import CopaMestreDoAcaiKidsDeJiuJitsu2025 from "./pages/tournament/copa-mestre-do-acai-kids-de-jiu-jitsu-2025";
import UserManagement from "./pages/profile/userManagement";
import { AdminEditUser } from "./pages/profile/adminEditUser";
import OpenParanavaiBrazilianDeJiuJitsu2025 from "./pages/tournament/open-paranavai-brazilian-de-jiu-jitsu-2025";
import NoroesteOpenDeJiuJitsu2025 from "./pages/tournament/noroeste-open-de-jiu-jitsu-2025";
import IvOpenParaguacuPaulistaDeJiuJitsu2025 from "./pages/tournament/iv-open-paraguacu-paulista-de-jiu-jitsu-2025";
import IiiCopaChampionsKidsICopaBushidoAdultoDeJiuJitsu2025 from "./pages/tournament/iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025";
import OpenLaranjeirasDoSulDeJiuJitsu2025 from "./pages/tournament/open-laranjeiras-do-sul-de-jiu-jitsu-2025";
import CopaTomeyaSasaharaDeJiuJitsu2025 from "./pages/tournament/copa-tomeya-sasahara-de-jiu-jitsu-2025";
import ICopaFaixaSolidariaDeJiuJitsu2025 from "./pages/tournament/i-copa-faixa-solidaria-de-jiu-jitsu-2025";
import ToledoOpenBrazilianDeJiuJitsu2025 from "./pages/tournament/toledo-open-brazilian-de-jiu-jitsu-2025";
import CopaOpenExtremeManausDeJiuJitsu2025 from "./pages/tournament/copa-open-extreme-manaus-de-jiu-jitsu-2025";
import InstrucaoTestePagbank from "./pages/tournament/instrucao-teste-homologação-pagbank/instrucao-teste-pagbank";
import NewTournament from "./pages/tournament/newTournament";
import { EditAthletes } from "./pages/profile/editAthletes";
import { EditUser } from "./pages/profile/editUser";
import ConnectPayment from "./pages/profile/connectPayments";
import NewBankAccount from "./pages/profile/newBankAccount";
import ValidationConnectAccessToken from "./pages/profile/validationConnectAccessToken";
import EditBankAccount from "./pages/profile/editBankAccount";
import LinkedBankTournaments from "./pages/profile/LinkedBankTournaments";
import EditTournamentAccount from "./pages/profile/LinkedBankTournaments/components/EditTournamentAccount";
import SubscriptionOwner from "./pages/tournament-owner/subscriptions-owner";
import ReportDetailTournament from "./pages/report-details/ReportDetailtTournament";
import TournamentsManagement from "./pages/profile/tournamentManagement";
import XixCopaParanaDeJiuJitsu2026 from "./pages/tournament/xix-copa-parana-de-jiu-jitsu-2026";
import CircuitoInterDeJiuJitsu2026 from "./pages/tournament/circuito-internacional-de-jiu-jitsu-2026";
import CopaParintinenseDeJiuJitsu2026 from "./pages/tournament/copa-parintinense-de-jiu-jitsu-2026";
import IiCopaMercosulDeJiuJitsu2026 from "./pages/tournament/ii-copa-mercosul-de-jiu-jitsu-2026";
import StiOpenKidsDeJiuJitsu2026 from "./pages/tournament/sti-open-kids-de-jiu-jitsu-2026";
import CampeonatoDeJiuJitsuGladiadoresBjjJudo2026 from "./pages/tournament/campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026";
import IGrandSlamEstadualDeJiuJitsuFeminino2026 from "./pages/tournament/i-grand-slam-estadual-de-jiu-jitsu-feminino-2026";
import ViiiCopaCampeoesDeJiuJitsu2026 from "./pages/tournament/viii-copa-campeoes-de-jiu-jitsu-2026";
import CopaAmizadeDeJiuJitsu2026 from "./pages/tournament/copa-amizade-de-jiu-jitsu-2026";
import IvSeletivaManausOlimpicaDeJiuJitsu2025 from "./pages/tournament/iv-seletiva-manaus-olimpica-de-jiu-jitsu-2026";
import IvCopaClbjjDeJiuJitsu2026 from "./pages/tournament/iv-copa-clbjj-de-jiu-jitsu-2026";
import ICopaBjjTalentDeJiuJitsu2026 from "./pages/tournament/i-copa-bjj-talent-de-jiu-jitsu-2026";
import OpenFiveDeJiuJitsu2026 from "./pages/tournament/open-five-de-jiu-jitsu-2026";
import CircuitoFajjeCoariDeJiuJitsuCoariAm from "./pages/tournament/circuito-fajje-coari-de-jiu-jitsu-coari-am";
import ICircuitoAmazonenseFajjoManausAm from "./pages/tournament/i-circuito-amazonense-fajjo-manaus-am";
import OpenCambeDeJiuJitsu2026 from "./pages/tournament/open-cambe-de-jiu-jitsu-2026";
import ICampeonatoAmazonenseDeMmaAmador2026 from "./pages/tournament/i-campeonato-amazonense-de-mma-amador-2026";
import DesafioZonaNorteDeJiuJitsuManausAm2026 from "./pages/tournament/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026";
import PaymentManagement from "./pages/admin/payment-management";
import AthletesPerAcademy from "./pages/admin/athletes-per-academy";
import ManualPaymentsReport from "./pages/admin/manual-payments-report";
import UnpaidReport from "./pages/admin/unpaid-report";
import ViOpenTerraSantaDeJiuJitsu2026 from "./pages/tournament/vi-open-terra-santa-de-jiu-jitsu-2026";
import IiCopaBushidoDeJiuJitsu2026 from "./pages/tournament/ii-copa-bushido-de-jiu-jitsu-2026";
import ICampeonatoInternoCtTeamKombatDeJiuJitsu2026 from "./pages/tournament/i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026";
import XxxiCopaOrleyLobatoDeJiuJitsu2026 from "./pages/tournament/xxxiv-copa-orley-lobato-de-jiu-jitsu-2026";
import IiOpenChellengerDeJiuJitsu2026 from "./pages/tournament/ii-open-challenger-de-jiu-jitsu-2026";
import IiValenteKidsDeJiuJitsu2026 from "./pages/tournament/ii-valente-kids-de-jiu-jitsu-2026";

const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const ScrollToTopLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return <Outlet />;
};

const router = createBrowserRouter([
  {
    element: <ScrollToTopLayout />,
    children: [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/profile/subscription",
    element: <Subscription />,
  },
  {
    path: "/invalidateUnpayedCheckout",
    element: <InvalidateUnpayedCheckoutsPage />,
  },
  {
    path: "/check",
    element: <Check />,
  },
  {
    path: "/reportDetail/tournament/:slug",
    element: <ReportDetailTournament />,
  },
  {
    path: "/check/:slug/search",
    element: <AllCheck />,
  },
  {
    path: "/check/:slug/all",
    element: <AllCheckCategories />,
  },
  {
    path: "/profile/athletes",
    element: <Athletes />,
  },
  {
    path: "/profile/athletes/:id",
    element: <EditAthletes />,
  },
  {
    path: "/profile/edit/user",
    element: <EditUser />,
  },
  {
    path: "/athletes",
    element: <NewAthletes />,
  },
  {
    path: "/tournament/:id",
    element: <Tournament />,
  },
  {
    path: "/tournament/16-COPA-PARANA-DE-JIU-JITSU",
    element: <Tournament2 />,
  },
  {
    path: "/tournament/XXXI-COPA-ORLEY-LOBATO-DE-JIU-JITSU",
    element: <Tournament3 />,
  },
  {
    path: "/tournament/INTERNATIONAL-CIRCUIT",
    element: <TournamentInternationalCircuit />,
  },
  {
    path: "/tournament/ESTADUAL-GFTEAM-AMAZONAS",
    element: <GfTeamAmazonas />,
  },
  {
    path: "/tournament/vii-open-amazonas-top-team-de-jiu-jitsu",
    element: <ViiOpenAmazonasTopTeamDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-cianorte-de-jiu-jitsu",
    element: <CopaCianorteDeJiuJitsu />,
  },
  {
    path: "/tournament/VII-REI-DA-PRAIA---BEACH-WRESTLING",
    element: <ViiReiDaPraiaBeachWrestiling />,
  },
  {
    path: "/tournament/toledo-international-open-brazilian-jiu-jitsu-2023",
    element: <ToledoInternationalOpenBrazilianJiuJitsu />,
  },
  {
    path: "/tournament/1º-Copa-Arena-Parintins-de-Jiu-Jitsu",
    element: <_1CopaArenaParintins />,
  },
  {
    path: "/tournament/i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023-manaus-amazonas",
    element: <IReiERainhaDaPraiaBeachBoxingManausAmazonas2023ManausAmazonas />,
  },
  {
    path: "/tournament/open-guaraniacu-brazilian-jiu-jitsu-2024-ginasio-de-esportes-onofre-garbasheski-guaraniacu-pr",
    element: <OpenGuaraniacuJiuJitsu2024 />,
  },
  {
    path: "/tournament/copa-amizade-de-jiu-jitsu-2024-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr",
    element: <CopaAmizadeDeJiuJitsu2024 />,
  },
  {
    path: "/tournament/viii-rei-e-rainha-da-praia-beach-wrestling-2024-nossa-praia-sports",
    element: <ViiiReiERainhaDaPraiaBeachWrestling2024 />,
  },
  {
    path: "/tournament/seletiva-manaus-olimpica",
    element: <SeletivaManausOlimpica2024 />,
  },
  {
    path: "/tournament/copa-mestre-acai-de-jiu-jitsu-2024",
    element: <CopaMestreAcaiDeJiuJitsu2024 />,
  },
  {
    path: "/tournament/xxxii-copa-orley-lobato-de-jiu-jitsu",
    element: <XxxiiCopaOrleyLobatoDeJiuJitsu />,
  },
  {
    path: "/tournament/iv-open-terra-santa-de-jiu-jitsu",
    element: <IvOpenTerrSantaDeJiuJitsu />,
  },
  {
    path: "/tournament/xvii-copa-parana-de-jiu-jitsu",
    element: <XviiCopaParanaDeJiuJitsu />,
  },
  {
    path: "/tournament/i-orixicombat-open-jiu-jitsu",
    element: <IOrixicombatOpenJiuJitsu />,
  },
  {
    path: "/tournament/vi-rei-da-praia-de-jiu-jitsu-no-gi",
    element: <ViReiDaPraiaDeJiuJitsuNoGi />,
  },
  {
    path: "/tournament/ii-copa-champions-kids-de-jiu-jitsu",
    element: <IiCopaChampionsKidsDeJiuJitsu />,
  },
  {
    path: "/tournament/i-open-laranjeiras-do-sul-de-jiu-jitsu",
    element: <IOpenLaranjeirasDoSulDeJiuJitsu />,
  },
  {
    path: "/tournament/estadual-gf-team-amazonas-jiu-jitsu",
    element: <EstadualGfTeamAmazonasDeJiuJitsu />,
  },
  {
    path: "/tournament/iii-open-rocha-e-moraes-de-jiu-jitsu",
    element: <IiiOpenRochaEMoraesDeJiuJitsu />,
  },
  {
    path: "/tournament/ii-copa-arena-parintins-de-jiu-jitsu",
    element: <IiCopaArenaParintinsDeJiuJitsu />,
  },
  {
    path: "/tournament/i-copa-thomasi-de-jiu-jitsu",
    element: <ICopaThomasiDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-lobo-bravo-cresol-de-jiu-jitsu",
    element: <CopaLoboBravoCresolDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-fronteira-de-jiu-jitsu",
    element: <CopaFronteiraDeJiuJitsu />,
  },
  {
    path: "/tournament/i-copa-black-belt-de-jiu-jitsu",
    element: <ICopaBlackBeltDeJiuJitsu />,
  },
  {
    path: "/tournament/xxix-copa-luis-neto-jiu-jitsu",
    element: <XxixCopaLuisNetoDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-manacapuru-de-jiu-jitsu",
    element: <CopaManacapuruDeJiuJitsu />,
  },
  {
    path: "/tournament/etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu",
    element: <EtapaOriximinaXxxiiCopaOrleyDeJiuJitsu />,
  },
  {
    path: "/tournament/xviii-copa-parana-de-jiu-jitsu",
    element: <XviiiCopaParanaDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-in-the-guard-de-jiu-jitsu",
    element: <CopaInTheGuardDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-amizade-de-jiu-jistu-2025",
    element: <CopaAmizadeDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/vii-copa-campeoes-de-jiu-jitsu-2025",
    element: <ViiCopaCampeoesDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-torneio-facil-de-jiu-jitsu",
    element: <CopaTorneioFacilDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-mercosul-de-jiu-jitsu-2025",
    element: <CopaMercosulDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-condominio-moradas-londrina-de-jiu-jitsu",
    element: <Copacondominiomoradaslondrinadejiujitsu />,
  },
  {
    path: "/tournament/copa-santa-tereza-do-oeste-de-jiu-jitsu-2025",
    element: <CopaSantaTerezaDoOesteDeJiuJitsu />,
  },
  {
    path: "/tournament/ii-open-nhamunda-de-jiu-jitsu-2025",
    element: <IiOpenNhamundaDeJiuJitsu />,
  },
  {
    path: "/tournament/v-open-terra-santa-de-jiu-jitsu-2025",
    element: <VOpenTerraSantaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/iii-copa-bjj-cascavel-de-jiu-jitsu-2025",
    element: <IiiCopaBjjCascavelDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/ii-copa-thomasi-de-jiu-jitsu-2025",
    element: <IiCopaThomasiDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/keys/:tournamentSlug",
    element: <TournamentBracketsPage />,
  },
  {
    path: "/tournament/open-candoi-de-jiu-jitsu-2025",
    element: <OpenCandoiDeJiuJitsu />,
  },
  {
    path: "/tournament/copa-mestre-do-acai-de-jiu-jitsu-2025",
    element: <CopaMestreDoAcaiDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/copa-fronteira-de-jiu-jistu-2025",
    element: <CopaFronteiraDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/open-cascavel-international-de-jiu-jitsu-2025",
    element: <OpenCascavelInternationalDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/ii-copa-aquiles-de-jiu-jitsu-2025",
    element: <IiCopaAquilesDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/copa-lobo-bravo-cresol-de-jiu-jitsu-2025",
    element: <CopaLoboBravoCresolDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/i-valente-kids-de-jiu-jitsu-2025",
    element: <IValenteKidsDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/i-copa-leao-de-juda-de-jiu-jitsu-2025",
    element: <ICopaLeaoDeJudaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/xxxiii-copa-orley-lobato-de-jiu-jitsu-2025",
    element: <XxxiiiOrleyLobatoDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/open-five-de-jiu-jitsu-2025",
    element: <OpenFiveDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/viii-open-amazonas-top-team-de-jiu-jitsu-2025",
    element: <ViiiOpenAmazonasTopTeamDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/ix-rei-e-rainha-da-praia-beach-wrestling-2025",
    element: <IxReiERainhaDaPraiaBeachWrestling2025 />,
  },
  {
    path: "/tournament/copa-cianorte-de-jiu-jitsu-2025",
    element: <CopaCianorteDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/viii-lijjam-combat-de-jiu-jitsu-2025",
    element: <ViiiLijjamCombatDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/lijjam-combat-ix-de-jiu-jitsu-2026",
    element: <LijjamCombatIxDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/estadual-gfteam-amazonas-de-jiu-jitsu-2025",
    element: <EstadualGfTeamAmazonasDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/i-copa-eu-amo-parintins-de-jiu-jitsu-2025",
    element: <ICopaEuAmoParintisDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/foz-open-confronto-internacional-de-jiu-jitsu-2025",
    element: <FozOpenConfrontoInternacionalDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/open-challenger-de-jiu-jitsu-2025",
    element: <OpenChallengerDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/vii-rei-da-praia-de-jiu-jitsu-no-gi-2025",
    element: <ViiReiDaPraiaDeJiuJitsuNoGi2025 />,
  },
  {
    path: "/tournament/copa-mestre-do-acai-kids-de-jiu-jitsu-2025",
    element: <CopaMestreDoAcaiKidsDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/open-paranavai-brazilian-de-jiu-jitsu-2025",
    element: <OpenParanavaiBrazilianDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/noroeste-open-de-jiu-jitsu-2025",
    element: <NoroesteOpenDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/iv-open-paraguacu-paulista-de-jiu-jitsu-2025",
    element: <IvOpenParaguacuPaulistaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025",
    element: <IiiCopaChampionsKidsICopaBushidoAdultoDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/open-laranjeiras-do-sul-de-jiu-jitsu-2025",
    element: <OpenLaranjeirasDoSulDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/copa-tomeya-sasahara-de-jiu-jitsu-2025",
    element: <CopaTomeyaSasaharaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/i-copa-faixa-solidaria-de-jiu-jitsu-2025",
    element: <ICopaFaixaSolidariaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/toledo-open-brazilian-de-jiu-jitsu-2025",
    element: <ToledoOpenBrazilianDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/copa-open-extreme-manaus-de-jiu-jitsu",
    element: <CopaOpenExtremeManausDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/xi-copa-londrina-de-jiu-jitsu-2025",
    element: <XiCopaLondrinaDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/estadual-gfteam-amazonas-de-jiu-jitsu-2025-etapa-careiro",
    element: <EstadualGfTeamAmazonasDeJiuJitsu2025EtapaCareiro />,
  },
  {
    path: "/tournament/copa-arapongas-de-jiu-jitsu-2026",
    element: <CopaArapongasDeJiuJitsu2025 />,
  },
  {
    path: "/tournament/xix-copa-parana-de-jiu-jitsu-2026",
    element: <XixCopaParanaDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/circuito-internacional-de-jiu-jitsu-2026",
    element: <CircuitoInterDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/copa-parintinense-de-jiu-jitsu-2026",
    element: <CopaParintinenseDeJiuJitsu2026 />,
  },
   {
    path: "/tournament/ii-copa-mercosul-de-jiu-jitsu-2026",
    element: <IiCopaMercosulDeJiuJitsu2026 />,
  },
 {
    path: "/tournament/sti-open-kids-de-jiu-jitsu-2026",
    element: <StiOpenKidsDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026",
    element: <CampeonatoDeJiuJitsuGladiadoresBjjJudo2026 />,
  },
  {
    path: "/tournament/i-grand-slam-estadual-de-jiu-jitsu-feminino-2026",
    element: <IGrandSlamEstadualDeJiuJitsuFeminino2026 />,
  },
  {
    path: "/tournament/viii-copa-campeoes-de-jiu-jitsu-2026",
    element: <ViiiCopaCampeoesDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/seletiva-manaus-olimpica-de-jiu-jitsu-2026",
    element: <IvSeletivaManausOlimpicaDeJiuJitsu2025 />,
  },
 {
    path: "/tournament/copa-amizade-de-jiu-jitsu-2026",
    element: <CopaAmizadeDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/iv-copa-clbjj-de-jiu-jitsu-2026",
    element: <IvCopaClbjjDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/i-campeonato-amazonense-de-mma-amador-2026",
    element: <ICampeonatoAmazonenseDeMmaAmador2026 />,
  },
  {
    path: "/tournament/i-copa-bjj-talent-de-jiu-jitsu-2026",
    element: <ICopaBjjTalentDeJiuJitsu2026 />,
  },
{
    path: "/tournament/open-five-de-jiu-jitsu-2026",
    element: <OpenFiveDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/circuito-fajje-coari-de-jiu-jitsu-coari-am",
    element: <CircuitoFajjeCoariDeJiuJitsuCoariAm />,
  },
  {
    path: "/tournament/i-circuito-amazonense-fajjo-manaus-am",
    element: <ICircuitoAmazonenseFajjoManausAm />,
  },
  {
    path: "/tournament/open-cambe-de-jiu-jitsu-2026",
    element: <OpenCambeDeJiuJitsu2026 />,
  },
  {
    path: "/tournament/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026",
    element: <DesafioZonaNorteDeJiuJitsuManausAm2026 />,
  },
   {
    path: "/tournament/vi-open-terra-santa-de-jiu-jitsu-2026",
    element: <ViOpenTerraSantaDeJiuJitsu2026 />,
  },
   {
    path: "/tournament/ii-copa-bushido-de-jiu-jitsu-2026",
    element: <IiCopaBushidoDeJiuJitsu2026 />,
  },
   {
    path: "/tournament/i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026",
    element: <ICampeonatoInternoCtTeamKombatDeJiuJitsu2026 />,
  },
   {
    path: "/tournament/xxxi-copa-orley-lobato-de-jiu-jitsu-2026",
    element: <XxxiCopaOrleyLobatoDeJiuJitsu2026 />,
  },
  
 {
    path: "/tournament/ii-open-challenger-de-jiu-jitsu-2026",
    element: <IiOpenChellengerDeJiuJitsu2026 />,
  },
   {
    path: "/tournament/ii-valente-kids-de-jiu-jitsu-2026",
    element: <IiValenteKidsDeJiuJitsu2026 />,
  },




  

  {
    path: "/subscription/by-owner/:slug",
    element: <SubscriptionOwner />,
  },
  {
    path: "/tournament/instrucao-teste-pagbank",
    element: <InstrucaoTestePagbank />,
  },
  {
    path: "/tournament/instrucao-teste-connect",
    element: <InstrucaoTesteConnectPagbank />,
  },
  {
    path: "/enrollment/:slug",
    element: <Enrollment />,
  },
  {
    path: "/enrollment-update/:id/:slug",
    element: <EnrollmentUpdate />,
  },
  {
    path: "/payment-instructions/:slug",
    element: <PaymentEnrollment />,
  },
  {
    path: "/payment-instruction/:slug/:id",
    element: <PaymentEnrollment />,
  },
  {
    path: "/auth/active-account/:code",
    element: <ActiveAccount />,
  },
  {
    path: "/password-recovery",
    element: <PasswordRecovery />,
  },
  {
    path: "/crie-seu-torneio",
    element: <ExternalRedirect to="https://wa.me/5592981291027?text=Ol%C3%A1!%20Gostaria%20de%20criar%20meu%20torneio%20no%20Torneio%20F%C3%A1cil." />,
  },
  {
    path: "/auth/password-recovery/:code",
    element: <ChangePassword />,
  },
  {
    path: "/admin/subscriptions",
    element: <SubscriptionAdm />,
  },
  {
    path: "/tournament/subscriptions",
    element: <SubscriptionEvent />,
  },
  {
    path: "/tournament/new",
    element: <NewTournament />,
  },
  {
    path: "/tournament/connect-bank",
    element: <ConnectPayment />,
  },
  {
    path: "/tournament/connect-bank/new-bank",
    element: <NewBankAccount />,
  },
  {
    path: "/tournament/connect-bank/edit-bank/:id",
    element: <EditBankAccount />,
  },
  {
    path: "/tournament/connect-bank/validation",
    element: <ValidationConnectAccessToken />,
  },
  {
    path: "/tournament/connect-bank/linked-tournament",
    element: <LinkedBankTournaments />,
  },
  {
    path: "/tournament/connect-bank/edit-linked-tournament",
    element: <EditTournamentAccount />,
  },
  {
    path: "/tournament/payment-management",
    element: <PaymentManagement />,
  },
  {
    path: "/jander",
    element: <DividaJander />,
  },
  {
    path: "/admin/tournament/management",
    element: <TournamentsManagement />,
  },
  {
    path: "/admin/users/management",
    element: <UserManagement />,
  },
  {
    path: "/admin/users/edit/:id",
    element: <AdminEditUser />,
  },
  {
    path: "/admin/payment-management",
    element: <PaymentManagement />,
  },
  {
    path: "/admin/financial-dashboard",
    element: <FinancialDashboard />,
  },
  {
    path: "/admin/athletes-per-academy",
    element: <AthletesPerAcademy />,
  },
  {
    path: "/tournament/athletes-per-academy",
    element: <AthletesPerAcademy />,
  },
  {
    path: "/admin/manual-payments-report",
    element: <ManualPaymentsReport />,
  },
  {
    path: "/tournament/manual-payments-report",
    element: <ManualPaymentsReport />,
  },
  {
    path: "/admin/unpaid-report",
    element: <UnpaidReport />,
  },
  {
    path: "/tournament/unpaid-report",
    element: <UnpaidReport />,
  },
    ],
  },
]);

root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <React.Fragment>
        <ToastContainer />
        <GlobalStyle />
        <RouterProvider router={router} />
      </React.Fragment>
    </HelmetProvider>
  </ErrorBoundary>
);
